let isClickScrolling = false;
let targetScroll = 0;

// Get tab elements
const tabs = document.querySelectorAll(".Page_faq_category_tab");

// Header height and safe space
const safeSpace = 56;
const safeSpaceMobile = 164;
const header = document.querySelector("header");
const headerHeight = header ? header.offsetHeight : 0;
const offset = headerHeight + safeSpace;
const offsetMobile = headerHeight + safeSpaceMobile;

// Tab click
tabs.forEach(tab => {
    tab.addEventListener("click", function(e) {
        e.preventDefault();
        const targetSelector = this.getAttribute("href");
        const target = document.querySelector(targetSelector);
        if (!target) return;

        // Remove active class from other tabs
        tabs.forEach(t => t.classList.remove("active"));
        this.classList.add("active");

        // Calculate scroll position
        if(window.innerWidth >= 750){
            targetScroll = target.getBoundingClientRect().top + window.pageYOffset - offset;
        }
        else{
            targetScroll = target.getBoundingClientRect().top + window.pageYOffset - offsetMobile;
        }
        isClickScrolling = true;

        // Smooth scroll
        window.scrollTo({
            top: targetScroll,
            behavior: "smooth"
        });
    });
});

// On scroll - active based on visible category
function handleScroll() {
    if (window.innerWidth <= 750) return;

    const scrollPos = window.pageYOffset;

    // If we're in a click scroll, check if we've reached the target
    if (isClickScrolling) {
        if (Math.abs(scrollPos - targetScroll) < 2) {
            isClickScrolling = false;
        } else {
            return;
        }
    }

    // Update active tab based on visible section
    const currentPos = scrollPos + offset + 1;

    for (let tab of tabs) {
        const targetSelector = tab.getAttribute("href");
        const target = document.querySelector(targetSelector);
        if (!target) continue;

        const top = target.offsetTop;
        const bottom = top + target.offsetHeight;

        if (currentPos >= top && currentPos < bottom) {
            tabs.forEach(t => t.classList.remove("active"));
            tab.classList.add("active");
            break;
        }
    }
}

window.addEventListener("scroll", handleScroll);

// FAQ Category dropdown
if (window.innerWidth < 750) {
    document.querySelectorAll('.Page_faq_categories_dropdown').forEach(dropdown => {
        const selectedTextEl = dropdown.querySelector('.selected_faq_category');

        dropdown.addEventListener('click', function () {
            this.classList.toggle('active');

            this.querySelectorAll(
                '.Page_faq_categories_dropdown_menu .Page_faq_category_tab'
            ).forEach(tab => {
                tab.addEventListener('click', function (e) {
                    e.stopPropagation(); // prevent dropdown toggle

                    // remove active from siblings
                    this.parentElement.querySelectorAll('.Page_faq_category_tab')
                        .forEach(t => t.classList.remove('active'));

                    this.classList.add('active');

                    selectedTextEl.textContent = this.textContent.trim();

                    dropdown.classList.remove('active');
                });
            });
        });
    });
}

if (window.innerWidth < 750) {
    document.addEventListener('DOMContentLoaded', () => {
        const header = document.querySelector('header');
        const containers = document.querySelectorAll('.Page_faq_categories_tab_container');
        const sides = document.querySelectorAll('.Page_faq_sides');

        if (!header || !containers.length) return;

        containers.forEach(container => {
            const containerHeight = container.offsetHeight;
            const faqMain = container.closest('.Page_faq_main_new').querySelector('.Page_faqs_main_container');

            window.addEventListener('scroll', () => {
                const headerHeight = header.offsetHeight - 1;
                const containerTop = container.getBoundingClientRect().top;
                const containerTopDocument = containerTop + window.pageXOffset;
                console.log(containerTopDocument);

                // Stick when container hits bottom of header
                if (containerTop <= headerHeight) {
                    if (!container.classList.contains('sticky')) {
                        container.classList.add('sticky');
                    }
                } 

                // Add class to Page_faq_sides when top reaches 0
                sides.forEach(side => {
                    const sideTop = side.getBoundingClientRect().top;
                    const sideBottom = side.getBoundingClientRect().bottom;
                    if (sideTop <= -16 && faqMain.getBoundingClientRect().bottom > 0) {
                        side.classList.add('at-top');
                    } else {
                        side.classList.remove('at-top');
                        container.classList.remove('sticky');
                    }
                });
            });
        });
    });
}

